export default __webpack_public_path__ + "static/media/frontdoor_house1.dffb3b39.jpeg";